export class Option {
  static fromAny = (o: any) => new Option(o.id, o.name, o.id);

  constructor(
    public id: string,
    public name: string,
    public value: string // Descriptive
  ) {}
}
